import { render, staticRenderFns } from "./ConfigEstabelecimento.vue?vue&type=template&id=3ca4c29e&"
import script from "./ConfigEstabelecimento.vue?vue&type=script&lang=js&"
export * from "./ConfigEstabelecimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports